export function verticalGallery() {
    const sliderFor = $(".slider-for");
    const rtl = this.rtl;
    
    sliderFor.slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: ".slider-nav",
        rtl
    });

    $(".slider-nav").slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: ".slider-for",
        focusOnSelect: true,
        vertical: true,
        verticalSwiping: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 4,
                }
            },
        ]
    });

    $(document).on("keydown", function (event) {
        if(event.keyCode == 37) {
            sliderFor.slick("slickPrev");
        }
        if(event.keyCode == 39) {
            sliderFor.slick("slickNext");
        }
    });

    sliderFor.on("afterChange", function (event, slick, currentSlide, nextSlide) {
        sliderFor.find(".slick-current .play-btn").focus();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/vertical-gallery.js